import { action, makeObservable, observable, runInAction } from "mobx";
import TrainingTypesApi from "../../../../../services/api/v2/trainingTypes/TrainingTypes.api";
import { Category } from "../../../../../enums";

export class TrainingTypeSettingsModel {
  organisationId: number;
  @observable courseData: FP.Entities.ITrainingType[] = [];
  @observable moduleData: FP.Entities.ITrainingType[] = [];
  @observable componentData: FP.Entities.ITrainingType[] = [];
  @observable courseLoading: boolean = true;
  @observable moduleLoading: boolean = true;
  @observable componentLoading: boolean = true;
  @observable currentCategory: Category = Category.Course;
  trainingTypeProvider = TrainingTypesApi;

  /**
   *
   */
  constructor(organisationId: number) {
    makeObservable(this);
    this.organisationId = organisationId;
  }

  onMount = () => {
    this.loadCourseData();
    this.loadModuleData();
    this.loadComponentData();
  };

  onUnmount = () => {};

  @action
  setCategory = (category: Category) => {
    this.currentCategory = category;
  };

  loadCourseData = async () => {
    runInAction(() => (this.courseLoading = true));
    const res = await this.trainingTypeProvider.getAll(this.organisationId, Category.Course);
    if (!res.isError) {
      runInAction(() => {
        this.courseData = res.payload;
      });
    }
    runInAction(() => (this.courseLoading = false));
  };

  loadModuleData = async () => {
    runInAction(() => (this.moduleLoading = true));
    const res = await this.trainingTypeProvider.getAll(this.organisationId, Category.Module);
    if (!res.isError) {
      runInAction(() => {
        this.moduleData = res.payload;
      });
    }
    runInAction(() => (this.moduleLoading = false));
  };

  loadComponentData = async () => {
    runInAction(() => (this.componentLoading = true));
    const res = await this.trainingTypeProvider.getAll(this.organisationId, Category.Component);
    if (!res.isError) {
      runInAction(() => {
        this.componentData = res.payload;
      });
    }
    runInAction(() => (this.componentLoading = false));
  };
}
